/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Request_To_SpeakInputs */



/**
* | output |
* | --- |
* | "Request to Speak" |
*
* @param {Leveling_Perm_Request_To_SpeakInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_request_to_speak = /** @type {((inputs?: Leveling_Perm_Request_To_SpeakInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Request_To_SpeakInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запрос на выступление")
	return /** @type {LocalizedString} */ ("Request to Speak")
});